<template>
  <div :class="[b(), className]" :style="styleSizeName">
    <div :ref="id" :style="styleChartName">
      <div class="bqh-container" v-if="dataChart.length">
        <div class="bqh-container-item" @click="itemClick(item)" v-for="(item, index) in dataChart" :key="index">
          <div :style="titleStyle" class="bqh-container-item-title-container flex space-between">
            <div class="bqh-container-item-title">{{ item.meeting_title }}</div>
            <div :style="tipStyle" class="bqh-container-item-time">{{ item.meeting_time }}</div>
          </div>
          <div class="bqh-container-item-content-container">
            <div :title="item.meeting_contents" :style="contentStyle" class="bqh-container-item-content">
              {{ item.meeting_contents }}
            </div>
            <img class="bqh-container-item-content-img" :style="imgStyle"
                 :src="item.meeting_link"
                 alt="">
            <div :style="tipStyle" class="bqh-container-item-foot-container flex space-between">
              <div class="bqh-container-item-foot-title"></div>
              <div class="bqh-container-item-foot-number">参会人数：{{ item.meeting_number }} 人</div>
            </div>
          </div>
        </div>
      </div>
      <el-empty v-else></el-empty>
    </div>
  </div>
</template>

<script>
import {setPx} from "@/echart/util";

export default {
  name: "BQH",
  data() {
    return {};
  },
  components: {},
  computed: {
    titleStyle() {
      return {
        fontSize: setPx(this.option.titleFontSize),
        fontWeight: setPx(this.option.titleFontWeight),
        color: this.option.titleColor,
      }
    },
    contentStyle() {
      return {
        fontSize: setPx(this.option.contentFontSize),
        fontWeight: setPx(this.option.contentFontWeight),
        color: this.option.contentColor,
      }
    },
    tipStyle() {
      return {
        fontSize: setPx(this.option.tipFontSize),
        fontWeight: setPx(this.option.tipFontWeight),
        color: this.option.tipColor,
      }
    },
    imgStyle() {
      return {
        width: setPx(this.option.photoWidth),
        height: setPx(this.option.photoHeight),
      }
    }
  },
  watch: {},
  methods: {
    itemClick(item) {
      window.open(`https://hse.sinoma.com.cn/beforeclass/edit?id=${item.meeting_id}&type=view`)
    },
    resizeEarth() {
    },
    updateChart() {
    },
  },
};
</script>
<style lang="scss">
.bqh-container {
  overflow-y: auto;
  height: 100%;
}

.bqh-container-item-title-container {
  border-bottom: 1px solid rgb(21, 64, 127);
  padding-bottom: 10px;
}

.bqh-container-item-content {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3; /* 限制显示的行数 */
  -webkit-box-orient: vertical;
  word-wrap: break-word; /* 确保长单词可以换行 */
}

.bqh-container-item-content-container {
  padding-top: 10px;
}

.bqh-container-item-content-img {
  margin: 10px 0;
}

.bqh-container-item {
  padding: 10px;
  border: 1px solid rgb(21, 64, 127);
}

.space-between {
  justify-content: space-between;
}
</style>
